import React from 'react'

import ReactWhatsapp from "react-whatsapp";

import sareeredcolor from "../images/SAREE RED COLOR.jpg";
import sarelightcolor from "../images/SAREE Light color.jpg";
import sareeweddeing from "../images/Weeding Saree Red.jpg";
import sareedeepmarooncolor from "../images/DEEP MAROON.jpg";




import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'






function SareeTrending() {
    return (
        <div>

          
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={sareeredcolor} className="card-img-top" alt="sareeredcolor"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Saree </h5>
                                                <p className="card-text">Red color</p>
                                              

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9064837572'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9064837572" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={sarelightcolor} className="card-img-top" alt="sarelightcolor"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Saree</h5>
                                                <p className="card-text">Light color</p>
                                   
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9064837572'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9064837572" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={sareeweddeing} className="card-img-top" alt="sareeweddeing"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Saree </h5>
                                                <p className="card-text">Weeding collection</p>
                                   
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9064837572'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9064837572" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={sareedeepmarooncolor} className="card-img-top" alt="sareedeepmarooncolor"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Saree                     </h5>
                                                <p className="card-text">Deep maroon color</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9064837572'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9064837572" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>



            
           
            <br />

            <br />
        </div>
    )
}

export default SareeTrending